<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span class="ePub-B">PART ONE</span></p>
<p class="PT"><span class="ePub-B">DOORS OF PERCEPTION</span></p>
<p class="EP"><span class="ePub-I">There are things known and there are things unknown, and in between there are the doors of perception.</span></p>
<p class="EPC">—Aldous Huxley</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?3c93723b